/**
 * This image carousel is a wrapper around the Embla carousel library.
 * It is used to create a responsive image carousel that can be scrolled with the mouse wheel on desktop.
 * On mobile, the carousel will switch to a horizontal scroll.
 * Looping can be set from the parent component, other options are only internally set for now.
 */
class ImageCarousel extends HTMLElement {
  /**
   * Create a new image carousel.
   * @param {boolean} loop - Whether the carousel should loop.
   */
  constructor() {
    super();
    this.loop = this.getAttribute('loop') === 'true';
    this.emblaApi = null;
    this.options = {
      loop: this.loop,
      axis: 'y',
      align: 'start',
      dragFree: true,
      breakpoints: {
        '(max-width: 768px)': { axis: 'x', align: 'center', dragFree: false },
      },
    };
  }

  connectedCallback() {
    this.emblaApi = EmblaCarousel(this, this.options, [
      EmblaCarouselWheelGestures(),
    ]);
  }
}

customElements.define('image-carousel', ImageCarousel);
